import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StartComponent } from './start/start.component';
import { GameComponent } from './game/game.component';
import { BrowserComponent } from './browser/browser.component';


const routes: Routes = [
    { path: 'start', component: StartComponent },
    { path: 'game', component: GameComponent },
    { path: 'browser', component: BrowserComponent },
    {
        path: '',
        redirectTo: '/start',
        pathMatch: 'full'
    },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
